import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CausesService } from '../../services/causes.service';
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalOptions,
} from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { MethodsComponent } from '../modal/methods/methods.component';
import { ModalConfirmComponent } from '../modal/confirm/modal-confirm.component';
import { Alert } from '../../models/alert.model';
import { GlobalsService } from '../../services';
import { createBodyRequest } from '../../utils/requests';
import { methodsIds } from '../../utils/methods';
import { LoadingService } from '..';

import { saveAs } from 'file-saver';
import { PdaService } from '../../services/pda.service';
import { EventEmitterService } from '../../services/event-emitter.service';
@Component({
  selector: 'app-analisis',
  templateUrl: './analisis.component.html',
  styleUrls: ['./analisis.component.scss'],
})
export class AnalisisComponent implements OnInit {
  definitiveSelected: any;
  defPareto: any = [];
  defFive: any = [];
  defBrain: any = [];
  defIshi: any = [];
  causesIshi: any = [];
  causesFive: any = [];
  causesPare: any = [];
  causesBrain: any = [];
  criterios: any = [];
  causesDef: any = [];
  infoIshikawa: string;
  infoPareto:any = []
  body: any = { datos: [] };
  @Input() planSelected: any;
  @Input() savePlan: any;
  @Input() generateReport: any;
  methodSelected: any = [];
  methods: any = [];
  ishikawa = true;
  fiveWhy = true;
  pareto = true;
  Brainstorm = true;
  selectedCauses = true;
  analisis = false;
  loading = false;
  overwrite = false;
  @Output() public emitLoaded = new EventEmitter();
  @Output() public emitLoadingReport = new EventEmitter();
  @Output() public emitSaved = new EventEmitter();
  @Output() public emitMethods = new EventEmitter();

  @Output() public emitChangeSelected = new EventEmitter();
  lang: string;
  getGral: boolean =false;
  title_pareto: any;
  constructor(
    private causes: CausesService,
    private translate: TranslateService,
    private modalService: NgbModal,
    private globals: GlobalsService,
    private _loading: LoadingService,
    private _pda:PdaService,    
    private emitService: EventEmitterService
  ) { }

  ngOnInit(): void {
    this.lang = this.translate.currentLang;
    this.definitiveSelected = [];
    window.dispatchEvent(new Event('resize'));
    this.emitService.invokeClickSave.subscribe(res=>{
      if(res==='causas'){
        
        this.saveMethods('actions')
      }
    })
  }
  ngOnChanges(changes: SimpleChanges): void {

    if (this.planSelected.length != 0) {
      // console.log(this.planSelected);
      
        if(!this.generateReport){
          this.getGralCauses();
        }
       
        window.dispatchEvent(new Event('resize'));
      }else{
        this.methodSelected = [];
        this.emitMethods.emit(this.methodSelected);
      }
    
  }
  createReport() {
    // console.log("REPORT");
    this.emitLoadingReport.emit(true);
    let report;
    if (this.planSelected) {
      this._pda.getReport(this.planSelected.id).subscribe(
        (res) => {
          report = res;
          if (report) {
            saveAs(report, `${this.planSelected.nombre}.pdf`);
            Alert.buildSuccessAlert(
              this.translate.instant('action_plan.report')
            );
          }
          this.loading = false;
              this.emitLoadingReport.emit(false);
              this.emitSaved.emit(this.savePlan)
              this.emitChangeSelected.emit(this.planSelected.id);
          // console.log('REPORT', res);
        },
        (err) => {
          Alert.buildErrorAlert(
            this.translate.instant('action_plan.report_error')
          );
          console.log('ERROR REPORT', err);
              this.emitLoadingReport.emit(false);
              this.loading = false;

        }
      );
    }
  }
  /**
   * @name getMethods
   * @author Daniel Ramirez
   * @description GET a la api de metodos del plan de acción
   */
  getMethods(): void {
    this._loading.show();
    this.causes.getMethod(this.planSelected.id).subscribe((res: any) => {
      this.methodSelected = res.data.metodos_pda;
      this.emitMethods.emit(this.methodSelected);
      this.methods = [];
      this.definitiveSelected = [];
      this.defBrain = [];
      this.defFive = [];
      this.defIshi = [];
      this.defPareto = [];
      this.body = { datos: [] };
      console.log(this.methodSelected);
      
      this.emitLoaded.emit(true);
      this._loading.hide()
      // ORDEN ULTIMO AGREGADO
      this.methodSelected.sort(function (b, a) {
        return a.id - b.id;
      });
      // SE ARREGLAN LOS METODOS DEL GET PARA PASARLO AL INPUT DEL MODULO
      this.methodSelected.forEach((method) => {
        
        
        this.methods.push(method.metodo_analisis);
        // ISHIKAWA
        if (method.metodo_analisis.id == 1) {
          this.setIshikawa(method);
          this.infoIshikawa = method.informacion_extra;
        }
        // FIVE WHY
        if (method.metodo_analisis.id == 2) {
          this.setFiveWhy(method);
        }
        // PARETO
        if (method.metodo_analisis.id == 3) {
          this.setPareto(method);
          this.title_pareto=method.informacion_extra?.title?method.informacion_extra.title:null;

          this.infoPareto=method.informacion_extra?.config?method.informacion_extra.config:null;
          if(this.infoPareto){

            this.infoPareto.xAxys==''?this.infoPareto.xAxys=null:null;
            this.infoPareto.magnitude==''?this.infoPareto.magnitude=null:null;
            
          }
          
        }
        // BRAINSTORM
        if (method.metodo_analisis.id == 4) {
          this.setBrainstorm(method);
        }
      });
      console.log({method:this.methods});

    });
  }
  /**
   * @name setBrainstorm
   * @author Daniel Ramirez
   * @description SE PREPARA EL METODO LLUVIA DE IDEA PARA PASARLO AL MODULO RESPECTIVO
   */
  setBrainstorm(method: any): void {
    this.body.datos.push({
      metodo_analisis_id: method.id,
      methodId: method.metodo_analisis.id,
    });
    method.causas = [];
    method.criterios = method.informacion_extra;

    this.criterios = method.criterios;
    method.causas_analisis_pda.forEach((cause) => {
      method.causas.push({
        id: cause.id,
        description: cause.texto,
        selected: parseInt(cause.elegido, 0) === 1,
        definitiveSelected: parseInt(cause.elegido, 0) === 1,
        metodo_abierto: null,
        evidencias: null,
        anidar: false,
        dato: cause.dato,
      });
    });
  }
  /**
   * @name setPareto
   * @author Daniel Ramirez
   * @description SE PREPARA EL METODO PARETO PARA PASARLO AL MODULO RESPECTIVO
   */
  setPareto(method: any): void {
    this.body.datos.push({
      metodo_analisis_id: method.id,
      methodId: method.metodo_analisis.id,
    });

    method.causas = [];
    method.causas_analisis_pda.forEach((cause) => {
      method.causas.push({
        id: cause.id,
        description: cause.texto,
        selected: parseInt(cause.elegido, 0) === 1,
        magnitude: cause.dato.magnitude,
        probability: 0,
        consequence: 0,
        definitiveId: parseInt(cause.definitivo, 0) ,
        definitiveSelected: parseInt(cause.definitivo, 0) === 1,
        method: {
          id: 3,
          name: 'ParetoChart',
        },
      });
    });
  }
  /**
   * @name setIshikawa
   * @author Daniel Ramirez
   * @description SE PREPARA EL METODO ISHIKAWA PARA PASARLO AL MODULO RESPECTIVO
   */
  setIshikawa(method): void{
    method.causas = [];
    this.body.datos.push({
      metodo_analisis_id: method.id,
      methodId: method.metodo_analisis.id,
    });
    method.causas_analisis_pda.forEach((cause) => {
      method.causas.push({
        id: cause.id,
        description: cause.texto,
        selected: false,
        magnitude: 0,
        probability: 0,
        consequence: 0,
        definitiveSelected: true,
        method: {
          id: 1,
          name: 'IshikawaDiagram',
        },
      });
      cause.causa_analisis_pda_hijos.forEach((hijo) => {
        method.causas.push({
          id: hijo.id,
          description: hijo.texto,
          selected: parseInt(hijo.elegido, 0) === 1,
          magnitude: 0,
          probability: 0,
          consequence: 0,
          definitiveSelected: parseInt(hijo.definitivo, 0) === 1,
          fatherId: cause.id,
          method: {
            id: 1,
            name: 'IshikawaDiagram',
          },
        });
      });
    });
  }
  /**
   * @name setFiveWhy
   * @author Daniel Ramirez
   * @description SE PREPARA EL METODO 5 POR QUE PARA PASARLO AL MODULO RESPECTIVO
   */
  setFiveWhy(method): void{
    this.body.datos.push({
      metodo_analisis_id: method.id,
      methodId: method.metodo_analisis.id,
    });
    method.causas = [];
    method.causas_analisis_pda.forEach((cause) => {
      method.causas.push({
        id: cause.id,
        description: cause.texto,
        selected: parseInt(cause.elegido, 0) === 1,
        magnitude: 0,
        probability: 0,
        consequence: 0,
        definitiveSelected: parseInt(cause.definitivo, 0) === 1,
        method: {
          id: 2,
          name: 'FiveWhyDiagram',
        },
      });
      cause.causa_analisis_pda_hijos.forEach((hijo) => {
        method.causas.push({
          id: hijo.id,
          description: hijo.texto,
          selected: parseInt(hijo.elegido, 0) === 1,
          magnitude: 0,
          probability: 0,
          consequence: 0,
          definitiveSelected: parseInt(hijo.definitivo, 0) === 1,
          fatherId: cause.id,
          method: {
            id: 2,
            name: 'FiveWhyDiagram',
          },
        });
        hijo.causa_analisis_pda_hijos.forEach((hijo2) => {
          method.causas.push({
            id: hijo2.id,
            description: hijo2.texto,
            selected: parseInt(hijo2.elegido, 0) === 1,
            magnitude: 0,
            probability: 0,
            consequence: 0,
            definitiveSelected: parseInt(hijo2.definitivo, 0) === 1,
            fatherId: cause.id,
            method: {
              id: 2,
              name: 'FiveWhyDiagram',
            },
          });
          hijo2.causa_analisis_pda_hijos.forEach((hijo3) => {
            method.causas.push({
              id: hijo3.id,
              description: hijo3.texto,
              selected: parseInt(hijo3.elegido, 0) === 1,
              magnitude: 0,
              probability: 0,
              consequence: 0,
              definitiveSelected: parseInt(hijo3.definitivo, 0) === 1,
              fatherId: cause.id,
              method: {
                id: 2,
                name: 'FiveWhyDiagram',
              },
            });
            hijo3.causa_analisis_pda_hijos.forEach((hijo4) => {
              method.causas.push({
                id: hijo4.id,
                description: hijo4.texto,
                selected: parseInt(hijo4.elegido, 0) === 1,
                magnitude: 0,
                probability: 0,
                consequence: 0,
                definitiveSelected:
                  parseInt(hijo4.definitivo, 0) === 1,
                fatherId: cause.id,
                method: {
                  id: 2,
                  name: 'FiveWhyDiagram',
                },
              });
              hijo4.causa_analisis_pda_hijos.forEach((hijo5) => {
                method.causas.push({
                  id: hijo5.id,
                  description: hijo5.texto,
                  selected: parseInt(hijo5.elegido, 0) === 1,
                  magnitude: 0,
                  probability: 0,
                  consequence: 0,
                  definitiveSelected:
                    parseInt(hijo5.definitivo, 0) === 1,
                  fatherId: cause.id,
                  method: {
                    id: 2,
                    name: 'FiveWhyDiagram',
                  },
                });
              });
            });
          });
        });
      });
    });
  }
  /**
   * @name setVariables
   * @author Daniel Ramirez
   * @description SET A LAS VARIABLES PARA NUEVO PLAN SELECCIONADO
   */
  setVariables(): void{
    this.definitiveSelected = [];
    this.defBrain = [];
    this.defFive = [];
    this.defIshi = [];
    this.defPareto = [];
    this.causesBrain = [];
    this.causesFive = [];
    this.causesIshi = [];
    this.causesPare = [];
  }
  /**
   * @name getGralCauses
   * @author Daniel Ramirez
   * @description GET A LA API DE CAUSAS GENERALES SLECCIONADAS
   */
  getGralCauses(): void {
    this.setVariables();
    this.causes.getCausasGenerales(this.planSelected.id).subscribe(
      (res: any) => {
        
        
        this.causesDef = res.data;
        this.getMethods()
        this.getGral = true;
      },
      (err) => {
        console.log('ERRROR CAUSAS GRALES');
        this.getMethods()
        this.getGral = true;
      }
    );
  }
  resize(): void {
    window.dispatchEvent(new Event('resize'));
  }
  module(event): void {
  }
  /**
   * @name openMethods
   * @author Daniel Ramirez
   * @description SE ABRE EL MODAL DE SLECCION DE METODOS Y SE GUARDAN LOS DATOS
   */
  openMethods(): void {
    const modalRef = this.modalService.open(MethodsComponent, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      size: 'lg',
    });

    modalRef.componentInstance.data = this.methods;
    modalRef.componentInstance.clickClose.subscribe((resp: any) => {
      this._loading.show();

      const body = {
        metodo_analisis_pda: [
          {
            metodo_analisis_id: resp.id,
            informacion_extra: '',
          },
        ],
      };

      if (this.body.datos.length) {
        this.saveMethods('add', body);
      } else {
        this.causes.addMethod(this.planSelected.id, body).subscribe(
          (res) => {
            
            Alert.buildSuccessAlert(
              this.translate.currentLang == 'es'
                ? 'Método agregado'
                : 'Added method'
            );
            this.getGralCauses();
          },
          (err) => {
            console.log(err);

            Alert.buildErrorAlert(
              this.translate.currentLang == 'es'
                ? 'Error al agregar método'
                : 'Error adding method'
            );
            this._loading.hide();
          }
        );
      }
    });
  }
  infoChanges(event,from): void{
    // console.log(event);
    if(from=='ishikawa'){
      this.infoIshikawa = event;
    }else if (from == 'pareto'){
      this.infoPareto=event;
    }else if (from == 'paretoTitle'){
      this.title_pareto=event;
    }
    
  }
   /**
   * @name methodChanges
   * @author Daniel Ramirez
   * @description CATCH A LOS EVENTOS DE LOS MODULOS Y SE PREPARAN LAS CAUSAS PARA SU USO EN LISTA DE DEF Y PARA GUARDARLAS
   */
  methodChanges(event, method): void {
    const selFive = [];
    const selPar = [];
    const selIshi = [];
    const selBrain = [];
    if (method === 'ishikawa') {
      const causasIshi = [];
      if (event.data.definitive) {
        // console.log('ISHIKAWA BODY', event);
        // DEF
        event.data.definitive.forEach((element) => {
          selIshi.push(element);
        });
        // BODY
        event.data.causes.forEach(({ causes }, i) => {
          causasIshi.push({ causa: causes });
          causasIshi[i].causa.forEach((cause, j) => {
            causasIshi[i].causa[j] = {
              texto: cause.description,
              elegido: cause.selected ? 1 : 0,
              definitivo: cause.definitiveSelected ? 1 : 0,
              metodo_abierto: null,
              evidencias: null,
              dato: j !== 0 ? null : i + 1,
              anidar: j !== 0,
              id:cause.id
            };
          });
        });
      }
      this.defIshi = selIshi.filter((x) => x.definitiveSelected === true);
      this.causesIshi = causasIshi;
      
    }
    if (method === 'five') {
      const causasFive = [];

      if (event.data.definitive) {
        // DEF
        event.data.definitive.forEach((element) => {
          selFive.push(element);
        });
        // BODY
        event.data.causes.forEach(({ causes }, i) => {
          causasFive.push({ causa: causes });
          causasFive[i].causa.forEach((cause, j) => {
            causasFive[i].causa[j] = {
              texto: cause.description,
              elegido: j !== 0 ? 0 : 1,
              definitivo: cause.definitiveSelected ? 1 : 0,
              metodo_abierto: null,
              evidencias: null,
              dato: null,
              anidar: false,
              id:cause.id,
            };
          });
        });
      }
      this.causesFive = causasFive;
      
      this.defFive = selFive.filter((x) => x.definitiveSelected === true);
    }
    if (method === 'pareto') {
      
      const causasPare = [];
      if (event.data.definitive) {
        // DEF
        event.data.definitive.forEach((element) => {
          selPar.push(element);
        });
        // BODY
        event.data.causes[0].causes.forEach((cause, i) => {
          causasPare.push({
            texto: cause.description,
            elegido: cause.selected ? 1 : 0,
            definitivo: cause.definitiveSelected ? 1 : 0,
            dato: {
              magnitude: cause.magnitude,
              data: {
                ...cause.diagramData,
              },
              anidar: false,
            },
            id:cause.id
          });
        });
      }
      this.causesPare = causasPare;
      
      this.defPareto = selPar.filter((x) => x.definitiveSelected === true);
    }
    if (method === 'brainstorm') {
      const causasBrain = [];
      if (event.data.definitive) {
        // DEF
        event.data.definitive.forEach((element) => {
          element.method = { id: 4, name: 'Brainstorm' };
          selBrain.push(element);
        });
        // BODY
        event.data.causes.forEach((causes, i) => {
          
          causasBrain.push({
            texto: causes.causes[0].description,
            elegido: causes.causes[0].definitiveSelected ? 1 : 0,
            definitivo: causes.causes[0].definitiveSelected ? 1 : 0,
            dato: causes.causes[0].dato,
            metodo_abierto: null,
            evidencia: null,
            causa_analisis_pda_id: null,
            id:causes.causes[0].id
          });
        });
      }
      this.causesBrain = causasBrain;
      
      if (this.causesBrain.length) {
        this.causesBrain.forEach((element) => {
          const dato = [];
          element.dato.forEach((datos) => {
            dato.push(datos.value);
          });
          element.dato = dato;
        });
      }
      this.defBrain = selBrain.filter((x) => x.definitiveSelected === true);
    }
    this.definitiveSelected = [].concat(
      this.defFive,
      this.defIshi,
      this.defPareto,
      this.defBrain
    );

    this.definitiveSelected.filter((x) => x !== undefined);
    
      this.definitiveSelected.map((x) => {
        x.gralSelected = x.definitiveSelected;
        x.gralId=null;
      })
      if(this.causesDef.length){
        this.definitiveSelected.forEach(defSel => {
          this.causesDef.forEach(defCause => {
            if (defSel.id == defCause.causa_analisis_plan_id) {
              defSel.gralSelected = defCause.elegido == 1 ? true : false;
              defSel.gralId = defCause.id;
            }
          });
        });
      }    
  
  }
  /**
   * @name criteriosService
   * @author Daniel Ramirez
   * @description CATCH AL EVENTO MODIF DE CRITERIOS LLUVIA DE IDEAS
   */
  criteriosService(event): void {
    this.criterios = event;
  }
  saveDefinitiveCauses(): void {
    // console.log('def selected', this.definitiveSelected);
  }
  /**
   * @name deleteMethod
   * @author Daniel Ramirez
   * @description ABRE EL MODAL DE ELIMINACION DE METODOS Y SE GUARDAN LOS CAMBIOS
   */
  deleteMethod(id, methodId, methodName): void {
    const modalRef = this.modalService.open(ModalConfirmComponent, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      size: 'lg',
    });
    modalRef.componentInstance.title =
      this.translate.currentLang === 'es' ? 'ELIMINAR MÉTODO' : 'DELETE METHOD';
    modalRef.componentInstance.from = 'delete_method';
    modalRef.componentInstance.nombre =
      methodId == 1
        ? this.translate.instant(
          'action_plan.analisis.methods_diagram.ishikawa_diagram'
        )
        : methodId == 2
          ? this.translate.instant(
            'action_plan.analisis.methods_diagram.five_why_diagram'
          )
          : methodId == 3
            ? this.translate.instant(
              'action_plan.analisis.methods_diagram.pareto_chart'
            )
            : methodId == 4
              ? this.translate.instant(
                'action_plan.analisis.methods_diagram.brainstorm'
              )
              : null;
    modalRef.componentInstance.clickClose.subscribe((resp: any) => {
      this.saveMethods('delete', id);
    });
  }
  /**
   * @name deleteMethod
   * @author Daniel Ramirez
   * @description SE GUARDAN LOS METODOS Y CAUSAS DEFINITIVAS
   */
  saveMethods(from, data?): void {


    
    if(from =='actions'){
      this.loading=false
    }else{this.loading = true;}
    
    
    this.body.datos.forEach((element,idx) => {

      element.plan_pda_id = this.planSelected.id;
      element.usuario_id = this.globals.user.id;
      element.causas=[]
      
     
      if (this.causesIshi.length !=0 && element.methodId == 1) {
        element.causas = this.causesIshi;
        element.anidar = true;
        element.informacion_extra = this.infoIshikawa;
      }
      if (this.causesFive.length !=0 && element.methodId == 2) {
        element.causas = this.causesFive;
        element.anidar = true;
        element.informacion_extra = 'Situacion a tratar';
      }
      if (this.causesPare.length !=0 && element.methodId == 3) {
        element.causas = this.causesPare;
        element.anidar = false;
        element.informacion_extra = {config:this.infoPareto,title:this.title_pareto};
      }
      if (this.causesBrain.length !=0 && element.methodId == 4) {
        element.causas = this.causesBrain;
        element.criterios = this.criterios;
        element.anidar = false;
      }
    });
    // console.log(this.body.datos);
    
    if (this.body.datos.length != 0) {
     
      this.causes.saveMethods(this.body).subscribe(
        (res: any) => {
          
          const methods = res.data.metodos_pda;
          const defFive = [];
          const defIshi = [];
          const defPare = [];
          const defBrain = [];
          methods.forEach((method) => {
            if (method.metodo_analisis.id == 1) {
              // ISHIKAWA
              method.causas_analisis_pda.forEach((cause, i, arr) => {
                cause.causa_analisis_pda_hijos.forEach(hijo => {
                  if (hijo.elegido == 1) {
                    defIshi.push(hijo);
                  }
                });
              });
            }
            if (method.metodo_analisis.id == 2) {
              // FIVE WHY
              method.causas_analisis_pda.forEach((cause, i, arr) => {
                defFive.push(cause);
                cause.causa_analisis_pda_hijos.forEach(hijo => {
                  defFive[i] = hijo;
                  hijo.causa_analisis_pda_hijos.forEach(hijo2 => {
                    defFive[i] = hijo2;
                    hijo2.causa_analisis_pda_hijos.forEach(hijo3 => {
                      defFive[i] = hijo3;
                      hijo3.causa_analisis_pda_hijos.forEach(hijo4 => {
                        defFive[i] = hijo4;
                      });
                    });
                  });
                });
              });
            }
            if (method.metodo_analisis.id == 3) {
              // PARETO
              method.causas_analisis_pda.sort((b,a)=>a.dato.magnitude - b.dato.magnitude);

              method.causas_analisis_pda.forEach(cause => {

                if (cause.definitivo == 1) {
                  defPare.push(cause)
                }
              });

            }
            if (method.metodo_analisis.id == 4) {
              // BRAINSTORM
              method.causas_analisis_pda.forEach(cause => {
                if (cause.elegido == 1) {
                  defBrain.push(cause)
                }
              });

            }
          });
          const bodyCausas = {
            causas: []
          }
          for (let i = 0; i < this.defFive.length; i++) {
            const element = this.defFive[i];
            // tslint:disable-next-line: prefer-for-of
            for (let j = 0; j < defFive.length; j++) {
              const element2 = defFive[j];
              if (element.method.id == 2) {
                if(this.defFive[i].description==defFive[i].texto){
                  this.defFive[i].id = defFive[i].id;
                }
              }

            }
          }
          
          for (let i = 0; i < this.defIshi.length; i++) {
            if(this.defIshi[i].description==defIshi[i].texto){
              this.defIshi[i].id = defIshi[i].id;
            }

          }
          for (let i = 0; i < this.defPareto.length; i++) {
            const element = this.defPareto[i];
            if(this.defPareto[i].description==defPare[i].texto){
              this.defPareto[i].id = defPare[i].id;
            }
          }
          for (let i = 0; i < this.defBrain.length; i++) {
            const element = this.defBrain[i];
            if(this.defBrain[i].description==defBrain[i].texto){
              this.defBrain[i].id = defBrain[i].id;
            }
          }
          this.definitiveSelected = [].concat(
            this.defFive,
            this.defIshi,
            this.defPareto,
            this.defBrain
          );
          this.definitiveSelected.filter((x) => x !== undefined);
          this.definitiveSelected.forEach(element => {
            bodyCausas.causas.push({
              elegido: element.gralSelected ? 1 : 0,
              causa_id: element.id,
              metodo_analisis_id: element.method.id,
              texto: element.description,
              id:element.gralId
            });
          });
          if(bodyCausas.causas.length !== 0){
           
            this.causes.saveCausasGenerales(this.planSelected.id, bodyCausas).subscribe((res:any) => {
              // console.log(res);
              
              this.causesDef = res;
              if(this.causesDef.length){
                this.definitiveSelected.forEach(defSel => {
                  this.causesDef.forEach(defCause => {
                    if (defSel.id == defCause.causa_analisis_plan_id) {
                      defSel.gralSelected = defCause.elegido == 1 ? true : false;
                      defSel.gralId = defCause.id;
                    }
                  });
                });
                // console.log('CAUSAS GRALES', this.causesDef);
                if(from === 'actions'){
                  this.loading=false;
                  this.emitService.dataSaved('data')
                }
              }
  
            }, (err) => {
              console.log(err);
  
            });
          }else{
            bodyCausas.causas=null;
            this.causes.saveCausasGenerales(this.planSelected.id, bodyCausas).subscribe((res:any) => {
              // console.log(res);
              if(from === 'actions'){
                this.loading=false;
                this.emitService.dataSaved('data')
              }

            }, (err) => {
              console.log(err);
  
            });
          }
         
          if (from === 'add') {
            this.causes.addMethod(this.planSelected.id, data).subscribe(
              (res) => {
                
                Alert.buildSuccessAlert(
                  this.translate.currentLang == 'es'
                    ? 'Método agregado'
                    : 'Added method'
                );
                this.getMethods();
                this.loading=false;

              },
              (err) => {
                console.log(err);

                Alert.buildErrorAlert(
                  this.translate.currentLang == 'es'
                    ? 'Error al agregar método'
                    : 'Error adding method'
                );
                this.loading=false;
                this._loading.hide()

              }
            );
          } else if (from === 'delete') {
            this.causes.deleteMethod(this.planSelected.id, data).subscribe(
              (res) => {
                Alert.buildSuccessAlert(
                  this.translate.currentLang == 'es'
                    ? 'Método eliminado'
                    : 'Method removed'
                );
                this.getMethods();  
                this.loading=false;
              },
              (err) => {
                Alert.buildErrorAlert(
                  this.translate.currentLang == 'es'
                    ? 'Error al elimnar método'
                    : 'Error deleting method'
                );
                this.loading=false;

              }
            );
          }else if(from === 'general'){
            // this.emitChangeSelected.emit(this.planSelected.id);
            Alert.buildSuccessAlert(
              this.translate.currentLang == 'es'
                ? 'Método guardado'
                : 'Saved method'
            );

          if(this.generateReport){
            this.createReport()
          }else{
            this.loading = false;
          }
     
          }else if(from==='actions'){
            this.loading = false;
          } else {
            this.getMethods();  
            Alert.buildSuccessAlert(
              this.translate.currentLang == 'es'
                ? 'Método guardado'
                : 'Saved method'
            );
            this.loading = false;
          }
        },
        (err) => {
          console.log(err);
          Alert.buildErrorAlert(
            this.translate.currentLang == 'es'
              ? 'Error al guardar método'
              : 'Error saving method'
          );
          this.loading = false;
        }
      );
    }else{
       
      if(from === 'actions'){
        this.loading=false;
        this.emitService.dataSaved('no data')
      }
      if (from === 'add') {
        this.causes.addMethod(this.planSelected.id, data).subscribe(
          (res) => {
            
            Alert.buildSuccessAlert(
              this.translate.currentLang == 'es'
                ? 'Método agregado'
                : 'Added method'
            );
            this.getMethods()
          },
          (err) => {
            console.log(err);

            Alert.buildErrorAlert(
              this.translate.currentLang == 'es'
                ? 'Error al agregar método'
                : 'Error adding method'
            );
          }
        );
        this.loading = false;
      } else if (from === 'delete') {
        this.causes.deleteMethod(this.planSelected.id, data).subscribe(
          (res) => {
            Alert.buildSuccessAlert(
              this.translate.currentLang == 'es'
                ? 'Método eliminado'
                : 'Method removed'
            );
            this.getMethods()
            
          },
          (err) => {
            Alert.buildErrorAlert(
              this.translate.currentLang == 'es'
                ? 'Error al elimnar método'
                : 'Error deleting method'
            );
          }
        );
      }
      this.loading = false;
      this.savePlan = false;
      if(from === 'general'){
        this.emitSaved.emit(this.savePlan)
        this.emitChangeSelected.emit(this.planSelected.id);
      }
      
    }
  }
  ngAfterViewChecked(): void {
    //Called after every check of the component's view. Applies to components only.
    //Add 'implements AfterViewChecked' to the class.
    window.dispatchEvent(new Event('resize'));
  }
  
}
